export default "__VITE_ASSET__CTrGzC9d__"